import { Notes } from '@components/Notes/Notes'
import { useAppDispatch } from '@hooks/redux'
import { RoutePaths } from '@interfaces/routePaths'
import {
  clearBreadcrumbs,
  setActionsButton,
  setActiveSection,
  setInviteButton,
} from '@redux/site/siteSlice'
import { useEffect } from 'react'

export const Base = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Notes'))
    dispatch(clearBreadcrumbs())
    dispatch(setInviteButton(false))
    dispatch(setActionsButton(false))
  })

  return (
    <Notes
      fullWidth
      state={{
        history: [
          {
            title: 'Notes',
            href: RoutePaths.NOTES,
          },
        ],
      }}
    />
  )
}
